/* eslint-disable no-await-in-loop */
import moment from 'moment';
import { isEmpty, filter } from 'lodash';
import axiosInstance from '../components/utils/axios/axiosInstance';
import {
  SAVE_RESERVATIONS,
  REMOVE_RESERVATION,
  SAVE_RESERVATION_DONE
  // eslint-disable-next-line import/named
} from './constantsActions';

function saveReservationDone(reservation) {
  return {
    type: SAVE_RESERVATION_DONE,
    payload: reservation
  };
}

export function getReservations() {
  return async (dispatch, getState) => {
    const today = moment();
    const { id } = getState().auth;
    const isAdmin = !isEmpty(
      filter(
        getState().auth.roles,
        (role) => role.name === 'ROLE_ADMIN' && role.active === true
      )
    );

    if (isAdmin) {
      const { data } = await axiosInstance.get(
        `/admin/user/getAllReservations`
      );
      dispatch({ type: SAVE_RESERVATIONS, data });
    }

    const res = await axiosInstance.get(
      `/api/reservation/getUserReservations`,
      {
        params: {
          userId: id
        }
      }
    );

    dispatch({ type: SAVE_RESERVATIONS, data: res.data });
  };
}

export function saveReservation(reservation) {
  return async (dispatch, getState) => {
    const { id } = getState().auth;

    const { data } = await axiosInstance.post(
      `/api/reservation/saveReservation`,
      {
        carId: reservation.carId,
        lotId: reservation.lotId,
        reservationDate: moment(reservation.dateFrom).format('DD.MM.YYYY'),
        reservationDateTo: moment(reservation.dateTo).format('DD.MM.YYYY'),
        timeFrom: reservation.timeFrom,
        timeTo: reservation.timeTo,
        userId: id
      }
    );

    dispatch(saveReservationDone(data));
    return data;
  };
}

export function removeReservation(id, dispatch) {
  dispatch({ type: REMOVE_RESERVATION, reservationId: id });
}

export function deleteReservation(id) {
  return async (dispatch) => {
    await axiosInstance.post(
      '/api/reservation/toggleReservationActive',
      {},
      {
        params: {
          reservationId: id,
          active: false
        }
      }
    );

    dispatch({ type: REMOVE_RESERVATION, reservationId: id });
  };
}

export function filterAllReservations({ search }) {
  return async (dispatch) => {
    await axiosInstance
      .get('/admin/user/filterAllReservations', {
        params: {
          filter: search
        }
      })
      .then((res) => {
        dispatch({ type: 'REPLACE_RESERVATIONS', data: res.data });
      });
  };
}
